import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

// Render's free tier spins the backend down after ~15 min idle, and a cold
// start can take 50s+. A short timeout here silently drops real inquiries from
// the first visitor after a quiet stretch, so this is deliberately generous.
export const api = axios.create({
  baseURL: API,
  timeout: 60000,
  validateStatus: (status) => status < 500
});

const retryRequest = async (fn, retries = 2, delay = 1000) => {
  for (let i = 0; i <= retries; i++) {
    try {
      return await fn();
    } catch (err) {
      // A timeout or network error has no `err.response` — those are exactly
      // the cold-start case worth retrying. Client errors (4xx) won't change
      // on a retry, so let those through immediately.
      const isRetryable = !err.response || err.response.status >= 500;
      if (i === retries || !isRetryable) throw err;
      await new Promise(r => setTimeout(r, delay * (i + 1)));
    }
  }
};

export const createInquiry = (data) => retryRequest(() => api.post("/inquiries", data).then((r) => r.data));
export const verifyAdmin = (code) => api.post("/admin/verify", { code }).then((r) => r.data);
export const listInquiries = (code) =>
  retryRequest(() => api.get("/inquiries", { headers: { "X-Admin-Code": code } }).then((r) => r.data));
export const updateInquiry = (id, status, code) =>
  api.patch(`/inquiries/${id}`, { status }, { headers: { "X-Admin-Code": code } }).then((r) => r.data);
